import { render } from "./VolumeDiskOfferingSelectView.vue?vue&type=template&id=b25ed366&scoped=true"
import script from "./VolumeDiskOfferingSelectView.vue?vue&type=script&lang=js"
export * from "./VolumeDiskOfferingSelectView.vue?vue&type=script&lang=js"

import "./VolumeDiskOfferingSelectView.vue?vue&type=style&index=0&id=b25ed366&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b25ed366"]])

export default __exports__